var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrosshairLine = function SvgCrosshairLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 17.954a6 6 0 0 0 5.204-5.204H15.75v-1.5h2.204a6 6 0 0 0-5.204-5.204V8.25h-1.5V6.046a6 6 0 0 0-5.204 5.204H8.25v1.5H6.046a6 6 0 0 0 5.204 5.204V15.75h1.5zM12 19.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
  })));
};
export default SvgCrosshairLine;